import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import InfiniteScroll from 'redux-infinite-scroll'

import { TextInput } from 'components/dpc_input'
import CheckboxInput from 'components/checkbox/checkbox'
import { MainButton, CancelButton } from 'components/button'
import SelectDropdown from 'components/select/select'
import lessonsPickerActions from '../../redux/actions/lessonsPickerActions'
import findObject from 'helpers/findObject'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import { localize } from 'helpers/translator'

import classNames from 'classnames/bind'
import styles from './lessons_picker.scss'

import iconItemPlaceholder from '../../assets/loaders/item-placeholder.svg'
const searchIcon = <svg height="15" id="SvgjsSvg1000" width="14" version="1.1" viewBox="0 0 14 15"> <defs id="SvgjsDefs1001"/> <path id="SvgjsPath1007" d="M697 221.5C697 218.46243 699.46243 216 702.5 216C705.53757 216 708 218.46243 708 221.5C708 222.71845 707.60378 223.84437 706.93317 224.75593C707.03048 224.77695 707.1211500000001 224.82005 707.2 224.89000000000001C708.5300000000001 226.09 710.6800000000001 228.10000000000002 710.9200000000001 228.74C711.32 229.8 710.08 230.16 709.73 229.94C709.29687 229.68406 706.95476 227.25751 705.71799 225.96081999999998C704.81321 226.61466 703.7016 226.99999999999997 702.5 226.99999999999997C699.46243 226.99999999999997 697 224.53756999999996 697 221.49999999999997ZM702.5 226C704.98528 226 707 223.98528 707 221.5C707 219.01472 704.98528 217 702.5 217C700.01472 217 698 219.01472 698 221.5C698 223.98528 700.01472 226 702.5 226Z " fill="#b8c0c6" fillOpacity="1" transform="matrix(1,0,0,1,-697,-216)"/> </svg>

const cx = classNames.bind(styles)

class LessonsPicker extends Component {

	constructor() {
		super()
		this.options = [
			{
				value: 'date',
				type: 'desc',
				text: localize('global_lessons_sort_recent'),
			},
			{
				value: 'name',
				type: 'asc',
				text: localize('global_lessons_sort_name'),
			},
			{
				value: 'author',
				type: 'asc',
				text: localize('global_lessons_sort_author'),
			},
			{
				value: 'size',
				type: 'asc',
				text: localize('global_lessons_sort_size'),
			},
		]
		this.loadMoreHandler = this.loadMoreHandler.bind(this)
		this.applySearchQuery = this.applySearchQuery.bind(this)
	}

	componentDidMount() {
		this.props.actions.end()
	}

	loadMoreHandler() {
		//TODO fix this for all places where lessons picker is used
		/*if(this.props.lessonsPicker.show_all || this.props.lessonsPicker.searching_page === this.props.lessonsPicker.page) {
            return
        }*/
		if (this.props.lessonsPicker.show_all) {
			return
		}
		this.props.searchLessons()
	}

	cancel() {
		this.props.actions.cancel()
	}

	renderMessages() {
		const lessonsArray = this.props.lessonsPicker.show_all ? this.props.lessonsPicker.selected_lessons : this.props.lessonsPicker.lessons
		if (lessonsArray.length > 0) {
			const npps = () => lessonsArray.map(l => {
				const data = this.props.lessons[l].data
				const isSelected = this.props.lessonsPicker.selected_lessons.indexOf(l) !== -1
				return (
					<li
						key={data.entityUID}
						className={
							cx(
								'lessons_picker_result-list__item',
								{ 'lessons_picker_result-list__item--active': isSelected}
							)
						}
						onClick={() => {
							this.props.actions.toggleLesson(data.entityUID)
						}}
					>
						<img src={data.thumb} alt="" className={styles['lessons_picker_result-list__item__img']}/>
						<div className={styles['lessons_picker_result-list__item__txt']}>
							<h2 className={styles['lessons_picker_result-list__item__txt__title']}>{data.name}</h2>
							<p className={styles['lessons_picker_result-list__item__txt__author']}>by: <b>{data.author.data.name}</b></p>
						</div>
						{ this.props.showType && this.props.lessons[l].library_object_type === '3' &&
                                <span className={styles['lessons_picker_result-list__item-bundle']}>{localize('lessons_picker_result_list_item_bundle')}</span>
						}
						{ this.props.showPrice && data.finalPrice !== '0.00' &&
                                <span className={styles['lessons_picker_result-list__item-price']}>${data.finalPrice}</span>
						}
					</li>
				)
			})
			return [npps()]
		} else {
			const arr = []
			arr.push(<li key="placeholder1"><img className={styles['lessons_picker_result-list__item-placeholder']} src={iconItemPlaceholder} /></li>)
			return [...arr]
		}
	}

	applySearchQuery() {
		this.props.actions.applySearchQuery()
		this.loadMoreHandler()
	}

	updateSort(value) {
		const sort = findObject('value', value, this.options)
		this.props.actions.updateSort(sort.value, sort.type)
		this.loadMoreHandler()
	}

	updateSearchQuery(ev) {
		this.props.actions.updateSearchQuery(ev.target.value)
	}

	toggleShowAll() {
		this.props.actions.toggleShowAll()
	}

	shouldComponentUpdate(nextProps) {
		return this.props.lessonsPicker !== nextProps.lessonsPicker
	}

	elementContainer() {
		if (this.props.lessonsPicker.show_all === true && this.props.lessonsPicker.selected_lessons.length === 0) {
			return <span className={styles.lessons_picker_result__unselected}>{localize('global_lessons_no_selected')}</span>
		} else if (this.props.lessonsPicker.more === false && this.props.lessonsPicker.lessons.length === 0 && this.props.lessonsPicker.show_all === false) {
			return <span className={styles.lessons_picker_result__empty}>{localize('global_lessons_no_results')}</span>
		} else {
			return <InfiniteScroll
				items={this.renderMessages()}
				loadMore={this.loadMoreHandler}
				hasMore={this.props.lessonsPicker.more && !this.props.lessonsPicker.show_all}
				holderType='ul'
				className={styles['lessons_picker_result-list']}
				containerHeight='327px' />
		}
	}

	render() {

		const selectedLessonsText = this.props.lessonsPicker.selected_lessons.length ? ' ('+this.props.lessonsPicker.selected_lessons.length+')' : ''

		return (
			<div styleName='lessons_picker'>
				<h2 styleName='lessons_picker_title'>
					<span styleName='lessons_picker_title__text'>{this.props.title}</span>
					<b styleName='lessons_picker_title__foldername'>{this.props.folderName}</b>
				</h2>
				{this.props.subtitle &&
                    <p styleName='lessons_picker_subtitle'>{this.props.subtitle}</p>
				}

				<div styleName='lessons_picker_search'>

					<TextInput
						value={this.props.lessonsPicker.search}
						placeholder={this.props.placeholder}
						onChange={this.updateSearchQuery.bind(this)}
						onEnterKey={this.applySearchQuery}
						boxType='withIconButton'
						tabIndex={1}
						button={{
							data: searchIcon,
							props: {onClick: this.applySearchQuery},
						}} />

				</div>

				<div styleName='lessons_picker_select'>
					<SelectDropdown
						options= {this.options}
						value= {this.props.lessonsPicker.order_field}
						tabIndex={2}
						onChange={this.updateSort.bind(this)}
						disabled={this.props.lessonsPicker.show_all}
					/>
				</div>
				{this.elementContainer()}
				<div styleName='lessons_picker_showall'>
					<CheckboxInput id="show-all-selected" value={this.props.lessonsPicker.show_all} onChange={this.toggleShowAll.bind(this)}/>
					<label styleName='lessons_picker_showall__label' htmlFor="show-all-selected">{localize('add_lessons_toolbar_select_label')}</label>
				</div>
				<div styleName='lessons_picker_buttons'>
					<MainButton disabled={this.props.lessonsPicker.selected_lessons.length<1} onClick={this.props.saveLessons}>{localize('global_add')}{selectedLessonsText}</MainButton>
				</div>
				<div styleName='lessons_picker_buttons'>
					<CancelButton onClick={this.props.cancel}>{localize('global_cancel')}</CancelButton>
				</div>
			</div>

		)
	}
}

LessonsPicker.propTypes = {
	actions: PropTypes.object,
	lessonsPicker: PropTypes.object,
	lessons: PropTypes.object,
}

LessonsPicker.defaultProps = {
	showType: false,
	showPrice: false,
	title: localize('binders_lessons_picker_title'),
}

function mapStateToProps(state) {
	return {
		lessonsPicker: state.lessonsPicker,
		lessons: state.lessons,
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		end: lessonsPickerActions.end,
		toggleLesson: lessonsPickerActions.toggleLesson,
		toggleShowAll: lessonsPickerActions.toggleShowAll,
		updateSearchQuery: lessonsPickerActions.updateSearchQuery,
		applySearchQuery: lessonsPickerActions.applySearchQuery,
		resetPickerSearch: lessonsPickerActions.resetPickerSearch,
		updateSort: lessonsPickerActions.updateSort,
	}, dispatch)
}

export default
connect(mapStateToProps, mapDispatchToProps)(
	CSSModules(
		LessonsPicker, styles, {allowMultiple: true}
	)
)
